export function data() {
  return {
    time: ''
  }
}
